export const handleNumber = (e) => e.target.value.replace(/\D/, '');